import React, {useRef, useState} from 'react';
import {UseLoader} from "../../../../hooks/useLoader";
import {UsePermissions} from "../../../../hooks/usePermissions";
import {convertirModena} from "../../../../shared/utils/utils";
import {ColumnGroup} from "primereact/columngroup";
import {Row} from "primereact/row";
import {Column} from "primereact/column";
import {Toast} from "primereact/toast";
import {DataTable} from "primereact/datatable";
import {confirmDialog} from "primereact/confirmdialog";
import {
    eliminarLiquidacion,
    traerDetalleliquidacion,
    traerDetalleliquidacionAsociado
} from "../../../../api/liquidacion.service";

import {ModalDeatailHora} from "./ModalDeatailHora";

export const TableHora = ({liquidacion, factura, reload}) => {
    const toast = useRef(null);
    const [handleLoad] = UseLoader();
    const [permisos] = UsePermissions()
    const [showDeatail, setShowDeatail] = useState(false);
    const [dataEvent, setDataEvent] = useState([]);

    const valorHoraBruto = factura.valor_factura / factura.cant_horas;
    const valorHoraNeta = factura.valor_neto / factura.cant_horas;

    const valorHorasTotal = () => {
        let total = 0;
        for (let liq of liquidacion) {

            total += liq.cant_horas === '' ? 0 : Number(liq.cant_horas);

            liq.valor = liq.cant_horas === '' ? 0 : Number(liq.cant_horas) * valorHoraBruto;
            liq.valor_neto = liq.cant_horas === '' ? 0 : Number(liq.cant_horas) * valorHoraNeta;

        }


        return total;
    }

    const valorNetoTotal = () => {
        let total = 0;

        for (let liq of liquidacion) {

            total += liq.valor_neto === '' ? 0 : parseFloat(liq.valor_neto);

        }

        return convertirModena(total);
    }

    const valorBrutoTotal = () => {
        let total = 0;
        for (let liq of liquidacion) {
            total += liq.valor === '' ? 0 : parseFloat(liq.valor);
        }

        return convertirModena(total);
    }

    let footerGroup =
        <ColumnGroup>
            <Row>
                <Column footer="" colSpan={2} footerStyle={{marginLefth: '10px'}}/>
                <Column footer={valorHorasTotal}/>
                <Column footer={valorBrutoTotal}/>
                <Column footer={valorNetoTotal}/>

            </Row>
            <Row>


            </Row>
        </ColumnGroup>;


   const onDetalleAso = async (rowData) => {
       try {
           handleLoad(true);
           const response = await traerDetalleliquidacionAsociado({
               factura_id: factura.factura_id,
               asociado_id: rowData
           });
           handleLoad(false);
           if (response.estado !== 200) {
               toast.current?.show({severity: 'error', summary: 'Alerta', detail: response.mensaje, life: 3000});
               return;
           }
           setDataEvent(response.data)
           setShowDeatail(true);
       } catch (e) {
           handleLoad(false);
           console.log(e)
       }
    }

    const actionTemplateHora = function (rowData) {
        return (
            <div className="flex align-items-center justify-start">

                <button
                    disabled={(!permisos.consultar)}
                    className="btn primary-color-btn"
                    type="button"
                    onClick={() => onDetalleAso(rowData.asociado_id)}>
                    <i className="fa fa-edit"/>
                </button>
            </div>
        );
    }

    const ondetail = async () => {
        try {
            handleLoad(true);
            const response = await traerDetalleliquidacion({factura_id: factura.factura_id});
            handleLoad(false);
            if (response.estado !== 200) {
                toast.current?.show({severity: 'error', summary: 'Alerta', detail: response.mensaje, life: 3000});
                return;
            }
            setDataEvent(response.data)
            setShowDeatail(true);
        } catch (e) {
            handleLoad(false);
            console.log(e)
        }
    }

    const onDelete = () => {
        confirmDialog({
            message: '¿Estas seguro?',
            header: 'Confirmación',
            acceptLabel: "Si",
            rejectLabel: "No",
            accept: async () => {
                const factura = new Set(liquidacion.map(item => item.factura_id))
                let factura_id = 0;
                factura.forEach(e => {
                    factura_id = e;
                })
                handleLoad(true);
                const payload = {
                    factura_id,
                    datos: liquidacion
                }
                const response = await eliminarLiquidacion(payload);

                handleLoad(false)
                console.log(response)
                if (response.estado !== 200) {
                    toast.current?.show({severity: 'error', summary: 'Alerta', detail: response.mensaje, life: 3000});
                    return;
                }

                toast.current?.show({severity: 'success', summary: 'Exito', detail: response.mensaje, life: 3000});
                reload()
            }
        });
    }

    const header = (
        <div className="flex align-items-center ">
            <div>
                <button
                    className="danger-color-btn btn"
                    type="button"
                    disabled={(!permisos.eliminar)}
                    onClick={onDelete}
                >
                    <i className="fa fa-trash"/>
                </button>
            </div>
            <div>
                <button
                    className="primary-color-btn btn"
                    type="button"
                    disabled={(!permisos.consultar)}
                    onClick={ondetail}
                >
                    <i className="fa fa-address-book"/>
                </button>
            </div>
        </div>
    );

    const footer = (
        <div className="flex flex-col ">
            <p className={'p-2 text-sm text-teal-600 '}>
                Cantidad total horas: {factura.cant_horas}</p>
            <p className="p-2  text-sm">Valor jornada bruta: {convertirModena(valorHoraBruto)}</p>
            <p className="p-2  text-sm">Valor jornada neta: {convertirModena(valorHoraNeta)}</p>
        </div>
    );

    const valueBodyTemplateNeto = (rowData) => {
        return convertirModena(rowData.valor_neto);
    }
    const valueBodyTemplateBruto = (rowData) => {
        return convertirModena(rowData.valor);
    }
    const onHide = () => {
        setShowDeatail(false);
        setDataEvent([]);
    }
    return (
        <>
            <Toast ref={toast}/>

            <DataTable
                showGridlines
                value={liquidacion}
                size="small"
                editMode="cell"
                dataKey="id"
                header={header}
                footer={footer}
                footerColumnGroup={footerGroup}
                scrollable scrollHeight="400px"
                responsiveLayout="scroll">
                <Column header="Editar" style={{fontSize: ".8em", width: '5%'}} body={actionTemplateHora}/>
                <Column filter sortable field="afiliados" header="Afiliados" style={{width: '10%'}}></Column>
                <Column  filter sortable field="cant_horas" header="Cantidad de horas" style={{width: '10%'}}></Column>
                <Column filter sortable field="valor" body={valueBodyTemplateBruto} header="Valor bruto"
                        style={{width: '10%'}}></Column>
                <Column filter sortable field="valor_neto" body={valueBodyTemplateNeto} header="Valor Neto"
                        style={{width: '10%'}}></Column>

            </DataTable>
            <ModalDeatailHora show={showDeatail} hide={onHide} fields={dataEvent}/>
        </>
    );
};


